import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { I18n } from 'aws-amplify/utils';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from '@core/i18n/language.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { ToastsContainer } from '@core/toast/toast-component/toast.component';
import { NavbarComponent } from '@core/navbar/navbar.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AmplifyAuthenticatorModule, RouterOutlet, TranslocoDirective, ToastsContainer, NavbarComponent],
})
export class AppComponent {
  private readonly languageService = inject(LanguageService);
  private readonly authService = inject(AuthService);
  protected readonly isAuthenticated = toSignal(this.authService.getCurrentUser().pipe(map((u) => u.authenticated)), {
    initialValue: false,
  });

  constructor() {
    const language = this.languageService.findLanguage();
    I18n.setLanguage(language);
  }
}
